var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 936.33 929.38",
    style: {
      enableBackground: "new 0 0 936.33 929.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.27,
    y: 0.21,
    width: 936.13,
    height: 929.17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.86,417.59v432.84H96.53v-555.1c0-18.87,13.26-32.14,32.12-32.14h139.41v32.14H139.14 c-3.5,0-6.29,2.79-6.29,6.29v83.84h127.15v32.13H132.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.05,319.71v-56.59h35.61v56.59H302.05z M302.05,528.78V367.23h35.61v161.54H302.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.76,528.78V299.7c0-18.87,13.28-32.14,32.14-32.14h85.33v31.43h-76.25c-3.5,0-5.58,2.11-5.58,5.59 v224.19H381.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.38,538.48c-18.86,0-32.14-13.28-32.14-32.14v-51.23h35.64v46.34c0,3.5,2.11,5.58,5.6,5.58h85.57 c3.5,0,5.6-2.08,5.6-5.58V420.3c0-3.48-2.1-5.59-5.6-5.59h-94.67c-18.86,0-30.38-11.52-30.38-30.39V299.7 c0-18.87,13.26-32.14,32.14-32.14h98.51c18.86,0,32.14,13.27,32.14,32.14v46.67h-35.64v-41.79c0-3.48-2.1-5.59-5.58-5.59h-80.36 c-3.5,0-5.6,2.11-5.6,5.59v73.8c0,3.48,2.1,5.59,5.6,5.59h94.67c18.86,0,30.41,11.52,30.41,30.39v91.97 c0,18.86-13.28,32.14-32.14,32.14H562.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740.03,311.31v-43.24h35.64v43.24h56.68v31.43h-56.68v158.7c0,3.5,2.11,5.58,5.58,5.58h45.5v31.46h-54.58 c-18.86,0-32.14-13.28-32.14-32.14V342.74V311.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.76,850.18c-17.9,0-30.5-12.61-30.5-30.5V706.63c0-17.91,12.61-30.5,30.5-30.5h120.35v-98.8h33.8v272.86 H446.76z M567.11,705.95H455.37c-3.29,0-5.29,2-5.29,5.3v103.78c0,3.32,2,5.29,5.29,5.29h111.74V705.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M672.66,850.18c-17.9,0-30.5-12.61-30.5-30.5V577.54h33.82v237.5c0,3.32,1.97,5.29,5.29,5.29h106.42 c3.32,0,5.29-1.97,5.29-5.29v-237.5h33.82v242.14c0,17.9-12.61,30.5-30.5,30.5H672.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.14,612.67v-34.99h-288.9c-9.67,0-17.5,7.83-17.5,17.5v79.91h-25.45c-9.67,0-17.5,7.83-17.5,17.5v141.03 c0,9.67,7.83,17.5,17.5,17.5h162.95v-34.99H210.79V710.08h145.45v-34.99h-102.5v-62.41H525.14z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "82.26,85.86 119.7,85.86 119.7,214.11 140.25,214.11 140.25,85.86 177.69,85.86 177.69,67.05  82.26,67.05  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.09,112.37h-37.14V67.05H198.4v147.05h20.55v-83.28h37.14c7.91,0,11.6,4.24,11.6,13.34v69.94h20.55v-71.34 c0-9.11-2.64-16.52-7.85-22.04C275.15,115.18,266.98,112.37,256.09,112.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.17,120.55v-18.28H336.8c-5.04,0-9.13,4.1-9.13,9.14v28.99h-7.68c-5.04,0-9.14,4.1-9.14,9.14v55.2 c0,5.04,4.1,9.14,9.14,9.14h66.07V195.6h-56.93v-36.92h56.93V140.4h-40.12v-19.85H452.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.a2f45c61f613e600de18f7e86d6472d5.svg";
export { ForwardRef as ReactComponent };